import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle
} from 'react'

import useDebounce from '../useDebounced'
import s from './SearchBar.module.css'

const BusinessSearch = forwardRef(({ onBusinessSearch }, ref) => {
  const [searchValue, setSearchValue] = useState('')
  const debouncedSearchValue = useDebounce(searchValue, 500)
  const [disabled, setDisabled] = useState(true)

  const inputRef = useRef()
  const searchRef = useRef()

  const resetBusinessSearch = () => setSearchValue('')

  useImperativeHandle(ref, () => {
    return {
      resetBusinessSearch: () => {
        resetBusinessSearch()
      }
    }
  })

  useEffect(() => {
    setDisabled(false)
  }, [])

  // useLayoutEffect(() => {
  //   if (pageOffset > 220) {
  //     if (selectedRegion?.services?.length) {
  //       searchRef.current.classList.add(s.businessSearchWrapperTop)
  //     } else {
  //       searchRef.current.classList.add(s.businessSearchWrapperTopNoService)
  //     }
  //   } else {
  //     if (selectedRegion?.services?.length) {
  //       searchRef.current.classList.remove(s.businessSearchWrapperTop)
  //     } else {
  //       searchRef.current.classList.remove(
  //         s.businessSearchWrapperTopNoService
  //       )
  //     }
  //   }
  // }, [pageOffset])

  useEffect(() => {
    onBusinessSearch(debouncedSearchValue)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [debouncedSearchValue])

  return (
    <div
      id="business-search"
      ref={searchRef}
      className={s.businessSearchWrapper}
    >
      <input
        className={s.searchInput}
        ref={inputRef}
        value={searchValue}
        disabled={disabled}
        placeholder="Search CaribeEats Businesses"
        onChange={(e) => setSearchValue(e.target.value)}
      />
    </div>
  )
})

export default React.memo(BusinessSearch)
